module.exports = __webpack_public_path__ + "25e6a442f47c681ede8362673204eae9.png";